import React from "react";
import styles from "./assistant.module.css";
import { useSelector } from "react-redux";

const Assistant = () => {
  const oracular = useSelector((store) => store.messenger.oracular);
  return (
    <div className={styles.container}>
      <p><span className={styles.name}>{oracular.name}</span> - Zodiaq Astrologer Assistant</p>
    </div>
  );
};

export { Assistant };
